"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class CheckboxIcon extends React.Component {
    render() {
        if (this.props.checked) {
            return React.createElement("i", { className: "fa fa-check-square-o fa-fw pointer", "aria-hidden": "true", onClick: this.props.onClick });
        } else {
            return React.createElement("i", { className: "fa fa-square-o fa-fw pointer", "aria-hidden": "true", onClick: this.props.onClick });
        }
    }
}
exports.default = CheckboxIcon;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/CheckboxIcon.tsx
// module id = 1087
// module chunks = 0 1 2